export const messages = {
  loading: "กำลังโหลด...",
  homeWalkHint: "แตะพื้นเดิน · แท่นกระโดดได้ในระยะใกล้ · ของทึบขวางทาง",
  homeEditHint: "กดรายการเลือกชิ้น → ยืนยัน → แตะกริดวาง · เสร็จเมื่อแต่งจบ",
  homePlaceArmedHint: "แตะกริดวางชิ้นที่เลือก · จุดเหลือง = socket · เปิดรายการเลือกชิ้นใหม่",
  tapHint: "คลิกตัวละครเพื่อรวบรวม Focus",
  offlineGain: (seconds: number) =>
    `ได้รับรายได้ขณะไม่อยู่ (${formatShortDuration(seconds)})`,
} as const;

function formatShortDuration(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  if (h > 0) return `${h}ชม. ${m}น.`;
  if (m > 0) return `${m}น. ${s}วิ.`;
  return `${s}วิ.`;
}
